module.exports = __webpack_public_path__ + "img/domestic-1984-federation.5aba9a45.jpg";